import { useState, useContext, useRef, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import TevelCyberLogo from "../../../assets/img/TevelCyberFinalBlueLogo.png";
import LoginImage from "../../../assets/img/LoginIllustraion.png";
import { useNavigate } from "react-router-dom";
import UserService from "../../../services/UserService";
import AuthContext from "../../../auth/AuthContext";
import AlertService from "../../../services/AlertService";
import CyberBay from "../../../assets/img/CyberBayFinalBlueLogo.png";

const EmailVerifyOTP = () => {
  const [otp, setOtp] = useState(Array(8).fill(""));
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [loadingResend, setLoadingResend] = useState(false);
  const authContext = useContext(AuthContext);
  const submitControllerRef = useRef(null);

  const handleOtpChange = (e, index) => {
    const { value } = e.target;
    if (/^[a-zA-Z0-9]?$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      if (value && index < 7) {
        document.getElementById(`otp-${index + 1}`).focus();
      }
    }
  };
  const handleOtpKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      if (otp[index] === "") {
        if (index > 0) document.getElementById(`otp-${index - 1}`).focus();
      }
    } else if (e.key === "ArrowLeft" && index > 0) {
      document.getElementById(`otp-${index - 1}`).focus();
    } else if (e.key === "ArrowRight" && index < 7) {
      document.getElementById(`otp-${index + 1}`).focus();
    }
  };

  const handlePaste = (e, startIndex) => {
    e.preventDefault();
    const pasteData = e.clipboardData.getData("text");
    const cleanData = pasteData.replace(/[^a-zA-Z0-9]/g, "");

    if (!cleanData) return;

    const newOtp = [...otp];
    let j = startIndex;

    for (let i = 0; i < cleanData.length && j < 8; i++) {
      newOtp[j] = cleanData[i];
      j++;
    }
    setOtp(newOtp);
    const focusIndex = j < 8 ? j : 7;
    document.getElementById(`otp-${focusIndex}`).focus();
  };


const handleSubmit = async (event) => {
  event.preventDefault();
  const finalOtp = otp.join("");

  if (finalOtp.length < 8) return;

  if (submitControllerRef.current) {
    submitControllerRef.current.abort();
  }
  const controller = new AbortController();
  submitControllerRef.current = controller;

  setLoading(true);

  try {
    const result = await UserService.ValidateOTP(
      finalOtp,
      authContext,
      controller.signal
    );

    if (controller.signal.aborted) return;

    if (result.isSuccess) {
      //  authContext.setMFAVerified(false);
      //   navigate("/mfaq");
      authContext.setMFAVerified(true);
      navigate("/");
    } else {
      AlertService.error(result.errorMessage);
    }
  } catch (ex) {
    if (ex.name === "AbortError") return;
    console.error(ex);
  } finally {
    if (!controller.signal.aborted) setLoading(false);
  }
};

// Unmount cleanup
useEffect(() => {
  return () => {
    submitControllerRef.current?.abort();
  };
}, []);

  const handleResendOTP = async () => {
    setLoadingResend(true);
    try {
      const result = await UserService.SendOTP(authContext);
      if (result.isSuccess) {
        AlertService.success("A new OTP has been sent to your email.");
        // Reset OTP input
        setOtp(Array(8).fill(""));
      } else {
        AlertService.error(result.errorMessage);
      }
    } catch (ex) {
      console.error(ex);
    }
    finally {
      setLoadingResend(false);
    }
  };

  return (
    <div className="container-fluid min-vh-100 d-flex flex-column flex-xl-row p-0">
      <div className="col-xl-6 d-flex flex-column justify-content-center align-items-center p-3 p-lg-5 min-vh-100  ">
        <div className="d-none d-xl-block mt-2">
          <img
            src={TevelCyberLogo}
            alt="Company Logo"
            style={{ maxWidth: "217px", marginRight: "220px" }}
            className="img-fluid"
          />
        </div>
        <div className="d-flex flex-column justify-content-center align-items-center flex-grow-1 w-100">
          <div className="d-flex d-xl-none justify-content-between align-items-center gap-5 mt-3 mb-4">
            <img
              src={TevelCyberLogo}
              alt="Tevel Cyber Logo"
              className="img-fluid"
              style={{ width: "140px" }}
            />
            <img
              src={CyberBay}
              alt="Cyber Bay Logo"
              className="img-fluid"
              style={{ width: "120px" }}
            />
          </div>
          <div className="w-100 mb-xl-4" style={{ maxWidth: "531px" }}>
            <h4 className="mb-2 text-center text-xl-start">OTP Verification</h4>
            <p className="mb-4 text-center text-xl-start">
              Please enter the One-Time Password sent to your email in the
              textbox below.
            </p>

            <form onSubmit={handleSubmit}>
              <div className="d-flex justify-content-between mb-4 gap-2">
                {otp.map((digit, i) => (
                  <input
                    key={i}
                    id={`otp-${i}`}
                    type="text"
                    maxLength="1"
                    className="form-control text-center email-otp-input"
                    value={digit}
                    onChange={(e) => handleOtpChange(e, i)}
                    onKeyDown={(e) => handleOtpKeyDown(e, i)}
                    onPaste={(e) => handlePaste(e, i)}
                    autoComplete="off"
                    autoFocus={i === 0} 
                  />
                ))}
              </div>
              <div className="d-flex justify-content-between">
                <div className="">
                  <button
                    type="button"
                    className="btn w-100 custom-input btn-outline"
                    onClick={handleResendOTP}
                    disabled={loading}
                  >
                    {loadingResend ? (
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    ) : null}
                    {loadingResend ? "Resending..." : "Resend OTP"}
                  </button>
                </div>
                <div>
                  <button
                    type="submit"
                    className="btn w-100 px-4 custom-input btn-primary"
                    disabled={loading}
                  >
                    {loading ? (
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    ) : null}
                    {loading ? "Verifying..." : "Verify OTP"}
                  </button>
                </div>

              </div>

            </form>
          </div>
        </div>
        <footer className="mt-auto text-center w-100">
          <p className="text-muted small mb-0">
            © 2026 Tevel Cyber Corps Pvt. Ltd. All rights reserved - Version 2.2.0
          </p>
        </footer>
      </div>
      <div className="col-xl-6 d-none d-xl-flex flex-column login-bg  min-vh-100 align-items-center justify-content-center  ">
        <div className="p-5 mt-2">
          <img
            src={CyberBay}
            alt="CYBER BAY"
            className="img-fluid mb-4"
            width="130px"
          />
        </div>
        <div className='"d-flex flex-column justify-content-center align-items-center flex-grow-1 w-100 p-xl-5 '>
          <img
            src={LoginImage}
            alt="Decorative"
            className="img-fluid loginImg"
            style={{
              maxWidth: "690px",
              maxHeight: "484px",
              marginLeft: "130px",
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default EmailVerifyOTP;
